import { defineMessages } from '@transcend-io/internationalization';

export const takeControlConfirmMessages = defineMessages(
  'privacy-center.components.TakeControlConfirm.takeControlConfirm',
  {
    success: {
      defaultMessage: 'Request Submitted Successfully!',
      description:
        'The success message displayed when a request is submitted successfully.',
    },
    back: {
      defaultMessage: 'Back to actions',
      description:
        'The back button text to return to main workflow selection menu.',
    },
    disabledWorkflow: {
      defaultMessage:
        'You have already submitted a request of this same type! ' +
        'You can check the status of this request by closing this modal and clicking on the "Active Requests" button.',
    },
    disabledWorkflowForAccess: {
      defaultMessage:
        "You have already submitted an erasure or access request that's still being processed. " +
        'You can check the status of your open requests by closing this modal and clicking on the "Active Requests" button.',
    },
  },
);
